export default __webpack_public_path__ + "static/iphoneX-3936b30ca6f38e6bb5679e9e4ba73222.webp";